// Custom field definition schema
// User-defined device properties with type information

import { z } from 'zod';

/**
 * Custom field definition for user-defined device properties.
 *
 * Note on field_type: We keep 'integer' and 'double' (C++ names) rather than
 * collapsing to 'number' because:
 * 1. Round-trip fidelity — C++ needs the original type for deserialization
 * 2. UI behavior — integer fields should only accept whole numbers
 * 3. Validation — enables z.number().int() vs z.number() at runtime
 */
export const CustomFieldDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  field_type: z.enum(['boolean', 'integer', 'double', 'string']),
});

export type CustomFieldDefinition = z.infer<typeof CustomFieldDefinitionSchema>;
